export default "__VITE_ASSET__CdDfqbQm__"